import { Component } from "@angular/core";
import { CTableCell } from "../../../../core/ui/c-table/c-table-config";
import { toUrlFriendlySlug } from "src/app/shared/utils/url-slug.util";

@Component({
  selector: "app-digital-memory-log-list-copy-link-component",
  template: `
    <div style="display: flex; align-items: center; width: 100%;">
      <img
        (click)="extraData.copyLink(row.entity)"
        src="assets/icons/li_copy.svg"
        alt="Copy Link Icon"
        style="width: 20px; height: 20px; margin-right: 10px; cursor: pointer; flex-shrink: 0;"
      />
      <span
        style="flex: 1; font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
      >
        {{ window.location.origin }}/preview-{{ getUrlFriendlyName(row.entity.name) }}-{{
          row.entity.id || "undefined"
        }}
      </span>
    </div>
  `,
})
export class CopyLinkColComponent implements CTableCell {
  extraData;
  row;
  column;
  window = window; // Add this to use window in template

  getUrlFriendlyName(name: string): string {
    return toUrlFriendlySlug(name);
  }
}
